<!-- <p>choose-fabric-more-option works!</p> -->
<div class="fabric_cont_more_option">


	<button class="close_button" (click)="closeOption()">
		<span class="material-symbols-outlined">
			close
		</span>
	</button>
	<h2>
		Select Fabric
		<hr>
	</h2>
	<div class="filter_cont">
		<div class="searchbar_cont">
			<input type="text" [(ngModel)]="searchString" (input)="search()" placeholder="SEARCH">
			<span class="material-symbols-outlined">
				search
			</span>
		</div>
	</div>
	<div class="fabrics_image_cont">

		<ng-container *ngIf="madeToOrderFabric.id">
			<button class="{{deltaIndex==-2?'active':''}}" >
				<img src="{{madeToOrderFabric.heroImage}}" (click)="emitChooseMTOFabricData(-2,madeToOrderFabric)" (mouseenter)="openMoreMTOInfo(-2,madeToOrderFabric,'https://dummyimage.com/200x200/ccc/000')"
				/>
			</button>
		</ng-container>

		<ng-container *ngFor="let moreFabric of moreFabricList; let i = index">
			<button class="{{deltaIndex==i?'active':''}}" >
				<img src="{{moreFabric.fabricPreview.heroImage}}" (click)="emitChooseFabricData(i,moreFabric)" (mouseenter)="openMoreInfo(i,moreFabric,'https://dummyimage.com/200x200/ccc/000')" />
			</button>
		</ng-container>
	</div>
	<ng-container *ngIf="moreFabricDataForEmit.fabricPreview || mTOFabricDataForEmit.heroImage">
		<div class="button_cont">


				<div class="button_cont_inner">
					<ng-container >
						<a (click)="openFabricDetails()"><button>Fabric Details</button></a>
					</ng-container>

					<button class="total_countbutton" (click)="continueOptionInfo()">Continue</button>
				</div>
		</div>
	</ng-container>
	<fb-chose-fabric-more-option-info *ngIf="closeInfo" (closeOption)="closeInfo = false"  [chooseFabricMorePopupdata]="morePopupData"></fb-chose-fabric-more-option-info>

	<fb-choose-mto-fabric-more-option-info *ngIf="closeMTOFabricInfo"
	(closeMTOFabricOption)="closeMTOFabricInfo = false"  [chooseMTOFabricPopupData]="madeToOrderFabric"></fb-choose-mto-fabric-more-option-info>

</div>
<div class="overlay_pop_up_pd  for_fabric" (click)="closeOption()"></div>
